import { InlineIcon } from '@iconify/react';
import { FC, useCallback } from 'react';
import Divider from 'src/components/Divider';
import useConfirm from 'src/hooks/useConfirm';
import { BuyerInfo } from 'src/services/useInvoiceDetailsApi';

interface BuyerInfoDialogContentProps {
  buyerInfo: BuyerInfo | undefined;
}

interface BuyerInfoProps {
  buyerInfo: BuyerInfo | undefined;
}

const BuyerInfoDialogContent: FC<BuyerInfoDialogContentProps> = ({ buyerInfo }) => (
  <div className="min-w-[300px]">
    <div> Buyer : </div>
    <Divider />
    <div>{buyerInfo?.name}</div>
    <div>{buyerInfo?.companyName}</div>
    <div>{buyerInfo?.addressLine1}</div>
    <div>{buyerInfo?.addressLine2}</div>
    <div>
      {buyerInfo?.city}, {buyerInfo?.state} - {buyerInfo?.zipCode}
    </div>
    <div>{buyerInfo?.email}</div>
    {buyerInfo?.phone && (
      <div>
        <span className="font-semibold"> Phone: </span> {buyerInfo?.phone}
      </div>
    )}
    {buyerInfo?.fax && (
      <div>
        <span className="font-semibold">Fax: </span>
        {buyerInfo?.fax}
      </div>
    )}
  </div>
);

const BuyerInfoModal: FC<BuyerInfoProps> = ({ buyerInfo }) => {
  const { confirm } = useConfirm();

  const handleClick = useCallback(() => {
    confirm({
      title: 'Buyer Details',
      content: <BuyerInfoDialogContent buyerInfo={buyerInfo} />,
      cancelButtonText: 'Close',
      hasNoConfirmButton: true,
    });
  }, [confirm, buyerInfo]);
  return (
    <div title={buyerInfo?.name} className="p-1 text-[13px]">
      <div className="flex flex-row gap-1 items-center pb-1">
        <p className="font-bold"> Buyer </p>
        <span title={'View More'}>
          <InlineIcon
            icon="mdi:user-card-details-outline"
            onClick={handleClick}
            className="cursor-pointer"
          />
        </span>
      </div>
      <p>{buyerInfo?.name} </p>
    </div>
  );
};

export default BuyerInfoModal;
